import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TermAttendanceStatusDomainService from "../../../Domain/TermAttendanceStatus/TermAttendanceStatus.service";
const getBadgeColor = (status) => {
    switch (status.id) {
        case TermAttendanceStatusDomainService.ATTENDING_ID:
            return "success";
        case TermAttendanceStatusDomainService.STOPPED_ATTENDING_ID:
            return "danger";
        case TermAttendanceStatusDomainService.NEVER_ATTENDED_ID:
            return "danger";
        default:
            return "secondary";
    }
};
const TermAttendanceStatusBadge = ({ status, className, title, }) => status && (_jsx("span", { className: `badge badge-${getBadgeColor(status)} ${className !== null && className !== void 0 ? className : ""}`, title: title !== null && title !== void 0 ? title : status.description, children: status.name }));
export default TermAttendanceStatusBadge;
